export default __webpack_public_path__ + "images/DN.accfb79.png";